import styled from 'styled-components';
import { darken } from 'polished';

export const Content = styled.div`
  min-height: 100vh;
  margin-left: 0;
  transition: margin 0.25s ease-out;
  width: 12rem;
  background-color: #fff;
`;

export const SidebarHeader = styled.div`
  padding: 0.875rem 1.25rem;
  font-size: 1.2rem;
`;

export const MenuHeader = styled.div`
  padding: 0.4rem 1rem;
  font-size: 0.9rem;
  color: #fff;
  background-color: #222;
  border-top: 1px solid #cecece;
  border-bottom: 1px solid #cecece;
  cursor: pointer;

  &:hover {
    background-color: ${darken(0.1, '#222')};
  }
`;

export const MenuItem = styled.button`
  width: 100%;
  text-align: left;
  background-color: #fff;
  border: 0;
  padding: 0.4rem 1rem 0.4rem 0.6rem;
  font-size: 0.8rem;

  cursor: pointer;
  & + button {
    border-top: 1px solid #cecece;
  }

  &:hover {
    background-color: ${darken(0.1, '#fff')};
  }
`;

export const MenuLink = styled.div`
  width: 100%;
  display: block;
  cursor: pointer;
  padding: 0.4rem 1rem 0.4rem 0.6rem;
  background-color: #fff;
  a {
    display: block;
    width: 100%;
    text-align: left;
    text-decoration: none;
    border: 0;
    color: #000;
    font-size: 0.8rem;
  }
  & + div {
    border-top: 1px solid #cecece;
  }

  &:hover {
    background-color: ${darken(0.1, '#fff')};
  }
`;
